export default "__VITE_ASSET__B1ltNcg6__"